var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFrame08(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 108"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36 18C36 27.9411 27.9411 36 18 36C8.05887 36 0 27.9411 0 18C0 8.05887 8.05887 0 18 0C27.9411 0 36 8.05887 36 18Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7143 18.6875H16.2857C12.7857 18.6875 10 21.4648 10 24.875C10 25.5078 10.5 26 11.1429 26H24.8571C25.4643 26 26 25.5078 26 24.875C26 21.4648 23.1786 18.6875 19.7143 18.6875ZM11.7143 24.3125C12 22.0977 13.9286 20.375 16.2857 20.375H19.7143C22.0357 20.375 23.9643 22.0977 24.25 24.3125H11.7143ZM18 17C20.5 17 22.5714 14.9961 22.5714 12.5C22.5714 10.0391 20.5 8 18 8C15.4643 8 13.4286 10.0391 13.4286 12.5C13.4286 14.9961 15.4643 17 18 17ZM18 9.6875C19.5714 9.6875 20.8571 10.9531 20.8571 12.5C20.8571 14.082 19.5714 15.3125 18 15.3125C16.3929 15.3125 15.1429 14.082 15.1429 12.5C15.1429 10.9531 16.3929 9.6875 18 9.6875Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame08);
export default __webpack_public_path__ + "static/media/Frame_08.47e83c1da5bde0099d8f34d25ef51423.svg";
export { ForwardRef as ReactComponent };